import { render, staticRenderFns } from "./resetPsd.vue?vue&type=template&id=4e608bc9&scoped=true&"
import script from "./resetPsd.vue?vue&type=script&lang=js&"
export * from "./resetPsd.vue?vue&type=script&lang=js&"
import style0 from "./resetPsd.vue?vue&type=style&index=0&id=4e608bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e608bc9",
  null
  
)

export default component.exports